<template>
  <div class="main">
    <div class="content_wrap">
      <div class="box_title">
        <ul class="result_tab">
          <li
            @click="changeTab(item)"
            v-for="item in typeList"
            :key="item.id"
            class="tab_li"
            :class="current_tab == item.id ? 'current_tab' : 'normal_tab'"
          >
            {{ item.name }}
            <div></div>
          </li>
        </ul>
        <div class="title_right">
          <p>共购买{{ count }}个</p>
        </div>
      </div>
      <!-- 下面大盒子区域 -->
      <div class="content_box">
        <!-- 下面展示区 -->
        <div v-if="!isloading">
          <div class="video_none" v-if="!videoList.length">
            <img :src="img.none" alt="" />
          </div>
          <ul class="video_wrap">
            <li
              class="video_card"
              v-for="(item, index) in videoList"
              :key="index"
            >
              <div class="card_img" @mouseenter="getVideoIndex(index)">
                <router-link
                  :to="{
                    name: 'videodetail',
                    query: {
                      post_id: item.source_id,
                      timeStmp: Date.parse(new Date()),
                    },
                  }"
                >
                  <img
                    :title="item.title"
                    class="cover"
                    :src="item.cover"
                    alt=""
                  />
                  <img class="secret" :src="img.secret" alt="">
                  <i class="status_free" v-if="item.type != 1">免费下载</i>
                  <i class="status_img" v-else>付费下载</i>
                  <video
                  :id="'video_list'+index"
                    autoplay="autoplay"
                    muted
                    loop
                    :src="item.path"
                  ></video>
                </router-link>
              </div>
              <div class="card_message">
                <span :title='item.title' class="card_title">{{ item.title }}</span>
                <span class="card_time">{{
                  com.timeFormat(item.video_info.play_time)
                }}</span>
              </div>
            </li>
          </ul>
        </div>
        <loading v-if="isloading"></loading>
      </div>

    </div>
  </div>
</template>

<script>
import { Message } from "element-ui";
import loading from "./../../widget/loading";

export default {
  components: { loading },
  data() {
    return {
      isloading: true,
      isBuy: true,
      isUpload: false,
      count: 0,
      isAll: true,
      isVideo: false,
      isPicture: false,
      current_tab: 1,
      typeList: [
        // { id: 1, name: "全部购买" },
        { id: 1, name: "视频" },
        // { id: 3, name: "图片" },
      ],
      buyTimeOptions: [
        {
          value: "选项1",
          label: "1个月内购买",
        },
        {
          value: "选项2",
          label: "3个月内购买",
        },
        {
          value: "选项3",
          label: "今年内购买",
        },
      ],
      advertisement: {
        is_show: true,
        list: [],
      },
      buyTimeValue: "",
      videoList: [],
    };
  },
  methods: {
     getVideoIndex(index){
           $('#video_list'+index)[0].currentTime=0
    },
    getList() {
      this.isloading = true;

      let data = {
        uid: localStorage.userInfo && JSON.parse(localStorage.userInfo).id,
        source_token:
          localStorage.userInfo &&
          JSON.parse(localStorage.userInfo).source_token,
      };
      this.$store.dispatch("post", { url: "myBuy", data: data }).then((res) => {
        this.isloading = false;
        if (res) {
          this.videoList = res.data.list;
          this.count = res.data.count;
        }
      });
    },
    changeTab(item) {
      this.current_tab = item.id;
    },
    changeType(val) {
      this[val] = true;
      if (val == "isBuy") {
        this.isUpload = false;
      } else {
        this.isBuy = false;
      }
    },
  },
  mounted() {
    if (!this.isLogin()) {
      Message.warning("尚未登录，请您先登录");
      let _this = this;
      setTimeout(function () {
        _this.$store.commit("changePath", { path: "video" });
      }, 1000);
    } else {
      this.getList();
    }
  },
};
</script>
<style lang="less">
.advertisement_buy {
  margin-top: 20px;
  img {
    width: 100%;
    height: 100%;
  }
}
// 下拉选择框样式
.buy_time {
  .el-select {
    .el-input__inner {
      border: none;
      background-color: #f3f4f7;
      border-radius: 10px;
      width: 150px;
      font-size: 18px;
      color: #202020;
    }
  }
}

// 视频卡片样式
.video_wrap .video_card .el-card__body {
  padding: 0;
}

.video_wrap .el-card {
  border: none;
}
.buy_time .el-icon-arrow-up:before {
  content: "\e78f";
  color: #202020;
}
</style>
<style lang="less" scoped>
.video_none {
  text-align: center;
  padding: 60px;
}
.current_tab {
  div {
    height: 2px;
    bottom: 18px;
  }
}

.normal_tab {
  font-weight: normal;
  font-size: 16px;
}

div.content_wrap {
  width: 1300px;
  margin: 0 auto;
  min-height: calc(100vh - 239px);
  padding-bottom: 30px;
  .top_box {
    height: 80px;
    background: #ffffff;
    border-radius: 10px;
    margin-bottom: 20px;
    display: flex;
    justify-content: center;
    align-items: center;

    .top_title {
      display: flex;
      height: 40px;
      line-height: 40px;
      .top_text {
        font-size: 16px;
        color: #202020;
      }

      p:first-child {
        margin-right: 100px;
      }

      .active {
        font-size: 18px;
        font-weight: 600;
        background: linear-gradient(135deg, #34cfff 0%, #34cfff 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
    }
  }
  div.box_title {
    width: 1307px;
    height: 59px;
    line-height: 59px;
    background: #ffffff;
    padding: 0 30px;
    border-radius: 10px;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #e1e1e1;

    .title_right {
    }

    ul.result_tab {
      display: flex;
      width: 100%;

      .tab_li {
        color: #202020;
        margin-right: 52px;
        font-size: 14px;
      }
    }

    div.title_right {
      p {
        width: 90px;
        font-size: 14px;
        color: #666666;
      }
    }
  }
  div.content_box {
    .buy_time {
      margin-top: 10px;
    }

    // 展示区
    .video_wrap {
      display: flex;
      flex-wrap: wrap;

      .video_card {
        height: 201px;
        box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.1);
        box-sizing: border-box;
        background-color: #ffffff;
        border-radius: 10px;
        position: relative;
        width: calc((100% - 75px) / 4);
        margin-top: 20px;
        margin-bottom: 5px;
        margin-right: 25px;
        overflow: hidden;
        &:hover {
          box-shadow: 0px 2px 5px 0px rgba(65, 46, 46, 0.5);
        }
        &:nth-child(4n) {
          margin-right: 0;
        }
        .card_img {
          height: 171px;
          overflow: hidden;
          &:hover {
            .cover {
              display: none;
            }
            video {
              display: block;
              height: 100%;
            }
          }
          video {
            display: none;
            width: 100%;
          }
          .cover {
            width: 100%;
            height: 100%;
          }
        }

        .card_message {
          background: #ffffff;
          padding: 0 10px;
          display: flex;
          justify-content: space-between;
          font-size: 12px;
          line-height: 30px;
          .card_time {
            padding-left: 5px;
            background: #fff;
            display: inline-block;
            z-index: 1;
          }
        }
      }
    }
  }
}
</style>